/* eslint-disable jsx-a11y/alt-text */
import { Pagination as PaginationAntd } from "antd";
import requestService from "api/request";
import clsx from "clsx";
import useBreakpoint from "hooks/useBreakpoint";
import { formatNumber, formatVolume } from "lib/helpers/format";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { useAppSelector } from "store";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import { useDebounce } from "hooks/useDebounce";

const Market = () => {
  const breakpoint = useBreakpoint();
  const { t } = useTranslation();
  const { appGlobal } = useAppSelector((state) => state.app);
  const [searchTerm, setSearchTerm] = useState("");
  const debounceValue = useDebounce(searchTerm, 300);
  const naviagte = useNavigate();

  const [tokens, setTokens] = useState({
    tokens: [],
    total: 0,
  });

  const getTokens = async (page) => {
    try {
      const res = await requestService.get("/guest/tokens", {
        params: {
          page,
          filter: debounceValue,
        },
      });
      if (res && res.data) {
        setTokens(res.data.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getTokens();
  }, [debounceValue]);

  const onChangePage = async (pageNumber) => {
    getTokens(pageNumber);
  };

  return (
    <div className="market" data-v-70542be6="">
      <div data-v-9b31e286="" data-v-70542be6="">
        <div
          data-v-9b31e286=""
          className="marketHot px-16px box-border bg-v3BgSecondary h-32px flex items-center"
        >
          <img
            data-v-9b31e286=""
            src="./market_files/market-hot.svg"
            alt="market-hot"
          />
          <div
            data-v-9b31e286=""
            dir="ltr"
            className="overflow-hidden flex items-center marquee-box cursor-pointer"
          >
            <div
              data-v-9b31e286=""
              className="flex marquee flex-row gap-8px h-32px text-0px"
            >
              <div
                data-v-9b31e286=""
                className="flex gap-4px items-center px-8px box-border fill-width"
              >
                <span
                  data-v-9b31e286=""
                  className="text-12px font-500 leading-16px text-v3PrimaryText"
                >
                  TONCOIN/USDT
                </span>
                <span
                  data-v-9b31e286=""
                  className="text-12px leading-16px font-500 text-v3PrimaryText !text-v3TradeBuy"
                >
                  7.98425
                </span>
                <span
                  data-v-9b31e286=""
                  className="flex items-center text-v3PrimaryText !text-v3TradeBuy"
                >
                  <span data-v-9b31e286="" className="text-12px">
                    (
                  </span>
                  <div
                    data-v-9b31e286=""
                    className="min-w-42px flex items-center justify-center"
                  >
                    <span
                      data-v-9b31e286=""
                      dir="ltr"
                      className="text-12px leading-16px font-500 flex flex-nowrap flex-shrink-0 text-v3TradeBuyText"
                    >
                      {/**/}+2.10%
                    </span>
                  </div>
                  <span data-v-9b31e286="" className="text-12px">
                    )
                  </span>
                </span>
              </div>
              <div
                data-v-9b31e286=""
                className="flex gap-4px items-center px-8px box-border fill-width"
              >
                <span
                  data-v-9b31e286=""
                  className="text-12px font-500 leading-16px text-v3PrimaryText"
                >
                  NOT/USDT
                </span>
                <span
                  data-v-9b31e286=""
                  className="text-12px leading-16px font-500 text-v3PrimaryText !text-v3TradeBuy"
                >
                  0.019682
                </span>
                <span
                  data-v-9b31e286=""
                  className="flex items-center text-v3PrimaryText !text-v3TradeBuy"
                >
                  <span data-v-9b31e286="" className="text-12px">
                    (
                  </span>
                  <div
                    data-v-9b31e286=""
                    className="min-w-42px flex items-center justify-center"
                  >
                    <span
                      data-v-9b31e286=""
                      dir="ltr"
                      className="text-12px leading-16px font-500 flex flex-nowrap flex-shrink-0 text-v3TradeBuyText"
                    >
                      {/**/}+6.52%
                    </span>
                  </div>
                  <span data-v-9b31e286="" className="text-12px">
                    )
                  </span>
                </span>
              </div>
              <div
                data-v-9b31e286=""
                className="flex gap-4px items-center px-8px box-border fill-width"
              >
                <span
                  data-v-9b31e286=""
                  className="text-12px font-500 leading-16px text-v3PrimaryText"
                >
                  BTC/USDT
                </span>
                <span
                  data-v-9b31e286=""
                  className="text-12px leading-16px font-500 text-v3PrimaryText !text-v3TradeSell"
                >
                  66,140.97
                </span>
                <span
                  data-v-9b31e286=""
                  className="flex items-center text-v3PrimaryText !text-v3TradeSell"
                >
                  <span data-v-9b31e286="" className="text-12px">
                    (
                  </span>
                  <div
                    data-v-9b31e286=""
                    className="min-w-42px flex items-center justify-center"
                  >
                    <span
                      data-v-9b31e286=""
                      dir="ltr"
                      className="text-12px leading-16px font-500 flex flex-nowrap flex-shrink-0 text-v3TradeSellText"
                    >
                      {/**/}-1.29%
                    </span>
                  </div>
                  <span data-v-9b31e286="" className="text-12px">
                    )
                  </span>
                </span>
              </div>
              <div
                data-v-9b31e286=""
                className="flex gap-4px items-center px-8px box-border fill-width"
              >
                <span
                  data-v-9b31e286=""
                  className="text-12px font-500 leading-16px text-v3PrimaryText"
                >
                  BGB/USDT
                </span>
                <span
                  data-v-9b31e286=""
                  className="text-12px leading-16px font-500 text-v3PrimaryText !text-v3TradeSell"
                >
                  1.15209
                </span>
                <span
                  data-v-9b31e286=""
                  className="flex items-center text-v3PrimaryText !text-v3TradeSell"
                >
                  <span data-v-9b31e286="" className="text-12px">
                    (
                  </span>
                  <div
                    data-v-9b31e286=""
                    className="min-w-42px flex items-center justify-center"
                  >
                    <span
                      data-v-9b31e286=""
                      dir="ltr"
                      className="text-12px leading-16px font-500 flex flex-nowrap flex-shrink-0 text-v3TradeSellText"
                    >
                      {/**/}-0.70%
                    </span>
                  </div>
                  <span data-v-9b31e286="" className="text-12px">
                    )
                  </span>
                </span>
              </div>
              <div
                data-v-9b31e286=""
                className="flex gap-4px items-center px-8px box-border fill-width"
              >
                <span
                  data-v-9b31e286=""
                  className="text-12px font-500 leading-16px text-v3PrimaryText"
                >
                  MAND/USDT
                </span>
                <span
                  data-v-9b31e286=""
                  className="text-12px leading-16px font-500 text-v3PrimaryText !text-v3TradeBuy"
                >
                  0.77483
                </span>
                <span
                  data-v-9b31e286=""
                  className="flex items-center text-v3PrimaryText !text-v3TradeBuy"
                >
                  <span data-v-9b31e286="" className="text-12px">
                    (
                  </span>
                  <div
                    data-v-9b31e286=""
                    className="min-w-42px flex items-center justify-center"
                  >
                    <span
                      data-v-9b31e286=""
                      dir="ltr"
                      className="text-12px leading-16px font-500 flex flex-nowrap flex-shrink-0 text-v3TradeBuyText"
                    >
                      {/**/}+209.93%
                    </span>
                  </div>
                  <span data-v-9b31e286="" className="text-12px">
                    )
                  </span>
                </span>
              </div>
              <div
                data-v-9b31e286=""
                className="flex gap-4px items-center px-8px box-border fill-width"
              >
                <span
                  data-v-9b31e286=""
                  className="text-12px font-500 leading-16px text-v3PrimaryText"
                >
                  PEPE/USDT
                </span>
                <span
                  data-v-9b31e286=""
                  className="text-12px leading-16px font-500 text-v3PrimaryText !text-v3TradeSell"
                >
                  0.00001196849
                </span>
                <span
                  data-v-9b31e286=""
                  className="flex items-center text-v3PrimaryText !text-v3TradeSell"
                >
                  <span data-v-9b31e286="" className="text-12px">
                    (
                  </span>
                  <div
                    data-v-9b31e286=""
                    className="min-w-42px flex items-center justify-center"
                  >
                    <span
                      data-v-9b31e286=""
                      dir="ltr"
                      className="text-12px leading-16px font-500 flex flex-nowrap flex-shrink-0 text-v3TradeSellText"
                    >
                      {/**/}-0.97%
                    </span>
                  </div>
                  <span data-v-9b31e286="" className="text-12px">
                    )
                  </span>
                </span>
              </div>
              <div
                data-v-9b31e286=""
                className="flex gap-4px items-center px-8px box-border fill-width"
              >
                <span
                  data-v-9b31e286=""
                  className="text-12px font-500 leading-16px text-v3PrimaryText"
                >
                  ETH/USDT
                </span>
                <span
                  data-v-9b31e286=""
                  className="text-12px leading-16px font-500 text-v3PrimaryText !text-v3TradeBuy"
                >
                  3,542.60
                </span>
                <span
                  data-v-9b31e286=""
                  className="flex items-center text-v3PrimaryText !text-v3TradeBuy"
                >
                  <span data-v-9b31e286="" className="text-12px">
                    (
                  </span>
                  <div
                    data-v-9b31e286=""
                    className="min-w-42px flex items-center justify-center"
                  >
                    <span
                      data-v-9b31e286=""
                      dir="ltr"
                      className="text-12px leading-16px font-500 flex flex-nowrap flex-shrink-0 text-v3TradeBuyText"
                    >
                      {/**/}+0.67%
                    </span>
                  </div>
                  <span data-v-9b31e286="" className="text-12px">
                    )
                  </span>
                </span>
              </div>
              <div
                data-v-9b31e286=""
                className="flex gap-4px items-center px-8px box-border fill-width"
              >
                <span
                  data-v-9b31e286=""
                  className="text-12px font-500 leading-16px text-v3PrimaryText"
                >
                  PIRATE/USDT
                </span>
                <span
                  data-v-9b31e286=""
                  className="text-12px leading-16px font-500 text-v3PrimaryText !text-v3TradeBuy"
                >
                  0.3675
                </span>
                <span
                  data-v-9b31e286=""
                  className="flex items-center text-v3PrimaryText !text-v3TradeBuy"
                >
                  <span data-v-9b31e286="" className="text-12px">
                    (
                  </span>
                  <div
                    data-v-9b31e286=""
                    className="min-w-42px flex items-center justify-center"
                  >
                    <span
                      data-v-9b31e286=""
                      dir="ltr"
                      className="text-12px leading-16px font-500 flex flex-nowrap flex-shrink-0 text-v3TradeBuyText"
                    >
                      {/**/}+15.89%
                    </span>
                  </div>
                  <span data-v-9b31e286="" className="text-12px">
                    )
                  </span>
                </span>
              </div>
              <div
                data-v-9b31e286=""
                className="flex gap-4px items-center px-8px box-border fill-width"
              >
                <span
                  data-v-9b31e286=""
                  className="text-12px font-500 leading-16px text-v3PrimaryText"
                >
                  IO/USDT
                </span>
                <span
                  data-v-9b31e286=""
                  className="text-12px leading-16px font-500 text-v3PrimaryText !text-v3TradeSell"
                >
                  5.026
                </span>
                <span
                  data-v-9b31e286=""
                  className="flex items-center text-v3PrimaryText !text-v3TradeSell"
                >
                  <span data-v-9b31e286="" className="text-12px">
                    (
                  </span>
                  <div
                    data-v-9b31e286=""
                    className="min-w-42px flex items-center justify-center"
                  >
                    <span
                      data-v-9b31e286=""
                      dir="ltr"
                      className="text-12px leading-16px font-500 flex flex-nowrap flex-shrink-0 text-v3TradeSellText"
                    >
                      {/**/}-6.35%
                    </span>
                  </div>
                  <span data-v-9b31e286="" className="text-12px">
                    )
                  </span>
                </span>
              </div>
              <div
                data-v-9b31e286=""
                className="flex gap-4px items-center px-8px box-border fill-width"
              >
                <span
                  data-v-9b31e286=""
                  className="text-12px font-500 leading-16px text-v3PrimaryText"
                >
                  SOL/USDT
                </span>
                <span
                  data-v-9b31e286=""
                  className="text-12px leading-16px font-500 text-v3PrimaryText !text-v3TradeSell"
                >
                  144.498
                </span>
                <span
                  data-v-9b31e286=""
                  className="flex items-center text-v3PrimaryText !text-v3TradeSell"
                >
                  <span data-v-9b31e286="" className="text-12px">
                    (
                  </span>
                  <div
                    data-v-9b31e286=""
                    className="min-w-42px flex items-center justify-center"
                  >
                    <span
                      data-v-9b31e286=""
                      dir="ltr"
                      className="text-12px leading-16px font-500 flex flex-nowrap flex-shrink-0 text-v3TradeSellText"
                    >
                      {/**/}-2.33%
                    </span>
                  </div>
                  <span data-v-9b31e286="" className="text-12px">
                    )
                  </span>
                </span>
              </div>
              <div
                data-v-9b31e286=""
                className="flex gap-4px items-center px-8px box-border fill-width"
              >
                <span
                  data-v-9b31e286=""
                  className="text-12px font-500 leading-16px text-v3PrimaryText"
                >
                  TONCOIN/USDT
                </span>
                <span
                  data-v-9b31e286=""
                  className="text-12px leading-16px font-500 text-v3PrimaryText !text-v3TradeBuy"
                >
                  7.98425
                </span>
                <span
                  data-v-9b31e286=""
                  className="flex items-center text-v3PrimaryText !text-v3TradeBuy"
                >
                  <span data-v-9b31e286="" className="text-12px">
                    (
                  </span>
                  <div
                    data-v-9b31e286=""
                    className="min-w-42px flex items-center justify-center"
                  >
                    <span
                      data-v-9b31e286=""
                      dir="ltr"
                      className="text-12px leading-16px font-500 flex flex-nowrap flex-shrink-0 text-v3TradeBuyText"
                    >
                      {/**/}+2.10%
                    </span>
                  </div>
                  <span data-v-9b31e286="" className="text-12px">
                    )
                  </span>
                </span>
              </div>
              <div
                data-v-9b31e286=""
                className="flex gap-4px items-center px-8px box-border fill-width"
              >
                <span
                  data-v-9b31e286=""
                  className="text-12px font-500 leading-16px text-v3PrimaryText"
                >
                  NOT/USDT
                </span>
                <span
                  data-v-9b31e286=""
                  className="text-12px leading-16px font-500 text-v3PrimaryText !text-v3TradeBuy"
                >
                  0.019682
                </span>
                <span
                  data-v-9b31e286=""
                  className="flex items-center text-v3PrimaryText !text-v3TradeBuy"
                >
                  <span data-v-9b31e286="" className="text-12px">
                    (
                  </span>
                  <div
                    data-v-9b31e286=""
                    className="min-w-42px flex items-center justify-center"
                  >
                    <span
                      data-v-9b31e286=""
                      dir="ltr"
                      className="text-12px leading-16px font-500 flex flex-nowrap flex-shrink-0 text-v3TradeBuyText"
                    >
                      {/**/}+6.52%
                    </span>
                  </div>
                  <span data-v-9b31e286="" className="text-12px">
                    )
                  </span>
                </span>
              </div>
              <div
                data-v-9b31e286=""
                className="flex gap-4px items-center px-8px box-border fill-width"
              >
                <span
                  data-v-9b31e286=""
                  className="text-12px font-500 leading-16px text-v3PrimaryText"
                >
                  BTC/USDT
                </span>
                <span
                  data-v-9b31e286=""
                  className="text-12px leading-16px font-500 text-v3PrimaryText !text-v3TradeSell"
                >
                  66,140.97
                </span>
                <span
                  data-v-9b31e286=""
                  className="flex items-center text-v3PrimaryText !text-v3TradeSell"
                >
                  <span data-v-9b31e286="" className="text-12px">
                    (
                  </span>
                  <div
                    data-v-9b31e286=""
                    className="min-w-42px flex items-center justify-center"
                  >
                    <span
                      data-v-9b31e286=""
                      dir="ltr"
                      className="text-12px leading-16px font-500 flex flex-nowrap flex-shrink-0 text-v3TradeSellText"
                    >
                      {/**/}-1.29%
                    </span>
                  </div>
                  <span data-v-9b31e286="" className="text-12px">
                    )
                  </span>
                </span>
              </div>
              <div
                data-v-9b31e286=""
                className="flex gap-4px items-center px-8px box-border fill-width"
              >
                <span
                  data-v-9b31e286=""
                  className="text-12px font-500 leading-16px text-v3PrimaryText"
                >
                  BGB/USDT
                </span>
                <span
                  data-v-9b31e286=""
                  className="text-12px leading-16px font-500 text-v3PrimaryText !text-v3TradeSell"
                >
                  1.15209
                </span>
                <span
                  data-v-9b31e286=""
                  className="flex items-center text-v3PrimaryText !text-v3TradeSell"
                >
                  <span data-v-9b31e286="" className="text-12px">
                    (
                  </span>
                  <div
                    data-v-9b31e286=""
                    className="min-w-42px flex items-center justify-center"
                  >
                    <span
                      data-v-9b31e286=""
                      dir="ltr"
                      className="text-12px leading-16px font-500 flex flex-nowrap flex-shrink-0 text-v3TradeSellText"
                    >
                      {/**/}-0.70%
                    </span>
                  </div>
                  <span data-v-9b31e286="" className="text-12px">
                    )
                  </span>
                </span>
              </div>
              <div
                data-v-9b31e286=""
                className="flex gap-4px items-center px-8px box-border fill-width"
              >
                <span
                  data-v-9b31e286=""
                  className="text-12px font-500 leading-16px text-v3PrimaryText"
                >
                  MAND/USDT
                </span>
                <span
                  data-v-9b31e286=""
                  className="text-12px leading-16px font-500 text-v3PrimaryText !text-v3TradeBuy"
                >
                  0.77483
                </span>
                <span
                  data-v-9b31e286=""
                  className="flex items-center text-v3PrimaryText !text-v3TradeBuy"
                >
                  <span data-v-9b31e286="" className="text-12px">
                    (
                  </span>
                  <div
                    data-v-9b31e286=""
                    className="min-w-42px flex items-center justify-center"
                  >
                    <span
                      data-v-9b31e286=""
                      dir="ltr"
                      className="text-12px leading-16px font-500 flex flex-nowrap flex-shrink-0 text-v3TradeBuyText"
                    >
                      {/**/}+209.93%
                    </span>
                  </div>
                  <span data-v-9b31e286="" className="text-12px">
                    )
                  </span>
                </span>
              </div>
              <div
                data-v-9b31e286=""
                className="flex gap-4px items-center px-8px box-border fill-width"
              >
                <span
                  data-v-9b31e286=""
                  className="text-12px font-500 leading-16px text-v3PrimaryText"
                >
                  PEPE/USDT
                </span>
                <span
                  data-v-9b31e286=""
                  className="text-12px leading-16px font-500 text-v3PrimaryText !text-v3TradeSell"
                >
                  0.00001196849
                </span>
                <span
                  data-v-9b31e286=""
                  className="flex items-center text-v3PrimaryText !text-v3TradeSell"
                >
                  <span data-v-9b31e286="" className="text-12px">
                    (
                  </span>
                  <div
                    data-v-9b31e286=""
                    className="min-w-42px flex items-center justify-center"
                  >
                    <span
                      data-v-9b31e286=""
                      dir="ltr"
                      className="text-12px leading-16px font-500 flex flex-nowrap flex-shrink-0 text-v3TradeSellText"
                    >
                      {/**/}-0.97%
                    </span>
                  </div>
                  <span data-v-9b31e286="" className="text-12px">
                    )
                  </span>
                </span>
              </div>
              <div
                data-v-9b31e286=""
                className="flex gap-4px items-center px-8px box-border fill-width"
              >
                <span
                  data-v-9b31e286=""
                  className="text-12px font-500 leading-16px text-v3PrimaryText"
                >
                  ETH/USDT
                </span>
                <span
                  data-v-9b31e286=""
                  className="text-12px leading-16px font-500 text-v3PrimaryText !text-v3TradeBuy"
                >
                  3,542.60
                </span>
                <span
                  data-v-9b31e286=""
                  className="flex items-center text-v3PrimaryText !text-v3TradeBuy"
                >
                  <span data-v-9b31e286="" className="text-12px">
                    (
                  </span>
                  <div
                    data-v-9b31e286=""
                    className="min-w-42px flex items-center justify-center"
                  >
                    <span
                      data-v-9b31e286=""
                      dir="ltr"
                      className="text-12px leading-16px font-500 flex flex-nowrap flex-shrink-0 text-v3TradeBuyText"
                    >
                      {/**/}+0.67%
                    </span>
                  </div>
                  <span data-v-9b31e286="" className="text-12px">
                    )
                  </span>
                </span>
              </div>
              <div
                data-v-9b31e286=""
                className="flex gap-4px items-center px-8px box-border fill-width"
              >
                <span
                  data-v-9b31e286=""
                  className="text-12px font-500 leading-16px text-v3PrimaryText"
                >
                  PIRATE/USDT
                </span>
                <span
                  data-v-9b31e286=""
                  className="text-12px leading-16px font-500 text-v3PrimaryText !text-v3TradeBuy"
                >
                  0.3675
                </span>
                <span
                  data-v-9b31e286=""
                  className="flex items-center text-v3PrimaryText !text-v3TradeBuy"
                >
                  <span data-v-9b31e286="" className="text-12px">
                    (
                  </span>
                  <div
                    data-v-9b31e286=""
                    className="min-w-42px flex items-center justify-center"
                  >
                    <span
                      data-v-9b31e286=""
                      dir="ltr"
                      className="text-12px leading-16px font-500 flex flex-nowrap flex-shrink-0 text-v3TradeBuyText"
                    >
                      {/**/}+15.89%
                    </span>
                  </div>
                  <span data-v-9b31e286="" className="text-12px">
                    )
                  </span>
                </span>
              </div>
              <div
                data-v-9b31e286=""
                className="flex gap-4px items-center px-8px box-border fill-width"
              >
                <span
                  data-v-9b31e286=""
                  className="text-12px font-500 leading-16px text-v3PrimaryText"
                >
                  IO/USDT
                </span>
                <span
                  data-v-9b31e286=""
                  className="text-12px leading-16px font-500 text-v3PrimaryText !text-v3TradeSell"
                >
                  5.026
                </span>
                <span
                  data-v-9b31e286=""
                  className="flex items-center text-v3PrimaryText !text-v3TradeSell"
                >
                  <span data-v-9b31e286="" className="text-12px">
                    (
                  </span>
                  <div
                    data-v-9b31e286=""
                    className="min-w-42px flex items-center justify-center"
                  >
                    <span
                      data-v-9b31e286=""
                      dir="ltr"
                      className="text-12px leading-16px font-500 flex flex-nowrap flex-shrink-0 text-v3TradeSellText"
                    >
                      {/**/}-6.35%
                    </span>
                  </div>
                  <span data-v-9b31e286="" className="text-12px">
                    )
                  </span>
                </span>
              </div>
              <div
                data-v-9b31e286=""
                className="flex gap-4px items-center px-8px box-border fill-width"
              >
                <span
                  data-v-9b31e286=""
                  className="text-12px font-500 leading-16px text-v3PrimaryText"
                >
                  SOL/USDT
                </span>
                <span
                  data-v-9b31e286=""
                  className="text-12px leading-16px font-500 text-v3PrimaryText !text-v3TradeSell"
                >
                  144.498
                </span>
                <span
                  data-v-9b31e286=""
                  className="flex items-center text-v3PrimaryText !text-v3TradeSell"
                >
                  <span data-v-9b31e286="" className="text-12px">
                    (
                  </span>
                  <div
                    data-v-9b31e286=""
                    className="min-w-42px flex items-center justify-center"
                  >
                    <span
                      data-v-9b31e286=""
                      dir="ltr"
                      className="text-12px leading-16px font-500 flex flex-nowrap flex-shrink-0 text-v3TradeSellText"
                    >
                      {/**/}-2.33%
                    </span>
                  </div>
                  <span data-v-9b31e286="" className="text-12px">
                    )
                  </span>
                </span>
              </div>
              <div
                data-v-9b31e286=""
                className="flex gap-4px items-center px-8px box-border fill-width"
              >
                <span
                  data-v-9b31e286=""
                  className="text-12px font-500 leading-16px text-v3PrimaryText"
                >
                  TONCOIN/USDT
                </span>
                <span
                  data-v-9b31e286=""
                  className="text-12px leading-16px font-500 text-v3PrimaryText !text-v3TradeBuy"
                >
                  7.98425
                </span>
                <span
                  data-v-9b31e286=""
                  className="flex items-center text-v3PrimaryText !text-v3TradeBuy"
                >
                  <span data-v-9b31e286="" className="text-12px">
                    (
                  </span>
                  <div
                    data-v-9b31e286=""
                    className="min-w-42px flex items-center justify-center"
                  >
                    <span
                      data-v-9b31e286=""
                      dir="ltr"
                      className="text-12px leading-16px font-500 flex flex-nowrap flex-shrink-0 text-v3TradeBuyText"
                    >
                      {/**/}+2.10%
                    </span>
                  </div>
                  <span data-v-9b31e286="" className="text-12px">
                    )
                  </span>
                </span>
              </div>
              <div
                data-v-9b31e286=""
                className="flex gap-4px items-center px-8px box-border fill-width"
              >
                <span
                  data-v-9b31e286=""
                  className="text-12px font-500 leading-16px text-v3PrimaryText"
                >
                  NOT/USDT
                </span>
                <span
                  data-v-9b31e286=""
                  className="text-12px leading-16px font-500 text-v3PrimaryText !text-v3TradeBuy"
                >
                  0.019682
                </span>
                <span
                  data-v-9b31e286=""
                  className="flex items-center text-v3PrimaryText !text-v3TradeBuy"
                >
                  <span data-v-9b31e286="" className="text-12px">
                    (
                  </span>
                  <div
                    data-v-9b31e286=""
                    className="min-w-42px flex items-center justify-center"
                  >
                    <span
                      data-v-9b31e286=""
                      dir="ltr"
                      className="text-12px leading-16px font-500 flex flex-nowrap flex-shrink-0 text-v3TradeBuyText"
                    >
                      {/**/}+6.52%
                    </span>
                  </div>
                  <span data-v-9b31e286="" className="text-12px">
                    )
                  </span>
                </span>
              </div>
              <div
                data-v-9b31e286=""
                className="flex gap-4px items-center px-8px box-border fill-width"
              >
                <span
                  data-v-9b31e286=""
                  className="text-12px font-500 leading-16px text-v3PrimaryText"
                >
                  BTC/USDT
                </span>
                <span
                  data-v-9b31e286=""
                  className="text-12px leading-16px font-500 text-v3PrimaryText !text-v3TradeSell"
                >
                  66,140.97
                </span>
                <span
                  data-v-9b31e286=""
                  className="flex items-center text-v3PrimaryText !text-v3TradeSell"
                >
                  <span data-v-9b31e286="" className="text-12px">
                    (
                  </span>
                  <div
                    data-v-9b31e286=""
                    className="min-w-42px flex items-center justify-center"
                  >
                    <span
                      data-v-9b31e286=""
                      dir="ltr"
                      className="text-12px leading-16px font-500 flex flex-nowrap flex-shrink-0 text-v3TradeSellText"
                    >
                      {/**/}-1.29%
                    </span>
                  </div>
                  <span data-v-9b31e286="" className="text-12px">
                    )
                  </span>
                </span>
              </div>
              <div
                data-v-9b31e286=""
                className="flex gap-4px items-center px-8px box-border fill-width"
              >
                <span
                  data-v-9b31e286=""
                  className="text-12px font-500 leading-16px text-v3PrimaryText"
                >
                  BGB/USDT
                </span>
                <span
                  data-v-9b31e286=""
                  className="text-12px leading-16px font-500 text-v3PrimaryText !text-v3TradeSell"
                >
                  1.15209
                </span>
                <span
                  data-v-9b31e286=""
                  className="flex items-center text-v3PrimaryText !text-v3TradeSell"
                >
                  <span data-v-9b31e286="" className="text-12px">
                    (
                  </span>
                  <div
                    data-v-9b31e286=""
                    className="min-w-42px flex items-center justify-center"
                  >
                    <span
                      data-v-9b31e286=""
                      dir="ltr"
                      className="text-12px leading-16px font-500 flex flex-nowrap flex-shrink-0 text-v3TradeSellText"
                    >
                      {/**/}-0.70%
                    </span>
                  </div>
                  <span data-v-9b31e286="" className="text-12px">
                    )
                  </span>
                </span>
              </div>
              <div
                data-v-9b31e286=""
                className="flex gap-4px items-center px-8px box-border fill-width"
              >
                <span
                  data-v-9b31e286=""
                  className="text-12px font-500 leading-16px text-v3PrimaryText"
                >
                  MAND/USDT
                </span>
                <span
                  data-v-9b31e286=""
                  className="text-12px leading-16px font-500 text-v3PrimaryText !text-v3TradeBuy"
                >
                  0.77483
                </span>
                <span
                  data-v-9b31e286=""
                  className="flex items-center text-v3PrimaryText !text-v3TradeBuy"
                >
                  <span data-v-9b31e286="" className="text-12px">
                    (
                  </span>
                  <div
                    data-v-9b31e286=""
                    className="min-w-42px flex items-center justify-center"
                  >
                    <span
                      data-v-9b31e286=""
                      dir="ltr"
                      className="text-12px leading-16px font-500 flex flex-nowrap flex-shrink-0 text-v3TradeBuyText"
                    >
                      {/**/}+209.93%
                    </span>
                  </div>
                  <span data-v-9b31e286="" className="text-12px">
                    )
                  </span>
                </span>
              </div>
              <div
                data-v-9b31e286=""
                className="flex gap-4px items-center px-8px box-border fill-width"
              >
                <span
                  data-v-9b31e286=""
                  className="text-12px font-500 leading-16px text-v3PrimaryText"
                >
                  PEPE/USDT
                </span>
                <span
                  data-v-9b31e286=""
                  className="text-12px leading-16px font-500 text-v3PrimaryText !text-v3TradeSell"
                >
                  0.00001196849
                </span>
                <span
                  data-v-9b31e286=""
                  className="flex items-center text-v3PrimaryText !text-v3TradeSell"
                >
                  <span data-v-9b31e286="" className="text-12px">
                    (
                  </span>
                  <div
                    data-v-9b31e286=""
                    className="min-w-42px flex items-center justify-center"
                  >
                    <span
                      data-v-9b31e286=""
                      dir="ltr"
                      className="text-12px leading-16px font-500 flex flex-nowrap flex-shrink-0 text-v3TradeSellText"
                    >
                      {/**/}-0.97%
                    </span>
                  </div>
                  <span data-v-9b31e286="" className="text-12px">
                    )
                  </span>
                </span>
              </div>
              <div
                data-v-9b31e286=""
                className="flex gap-4px items-center px-8px box-border fill-width"
              >
                <span
                  data-v-9b31e286=""
                  className="text-12px font-500 leading-16px text-v3PrimaryText"
                >
                  ETH/USDT
                </span>
                <span
                  data-v-9b31e286=""
                  className="text-12px leading-16px font-500 text-v3PrimaryText !text-v3TradeBuy"
                >
                  3,542.60
                </span>
                <span
                  data-v-9b31e286=""
                  className="flex items-center text-v3PrimaryText !text-v3TradeBuy"
                >
                  <span data-v-9b31e286="" className="text-12px">
                    (
                  </span>
                  <div
                    data-v-9b31e286=""
                    className="min-w-42px flex items-center justify-center"
                  >
                    <span
                      data-v-9b31e286=""
                      dir="ltr"
                      className="text-12px leading-16px font-500 flex flex-nowrap flex-shrink-0 text-v3TradeBuyText"
                    >
                      {/**/}+0.67%
                    </span>
                  </div>
                  <span data-v-9b31e286="" className="text-12px">
                    )
                  </span>
                </span>
              </div>
              <div
                data-v-9b31e286=""
                className="flex gap-4px items-center px-8px box-border fill-width"
              >
                <span
                  data-v-9b31e286=""
                  className="text-12px font-500 leading-16px text-v3PrimaryText"
                >
                  PIRATE/USDT
                </span>
                <span
                  data-v-9b31e286=""
                  className="text-12px leading-16px font-500 text-v3PrimaryText !text-v3TradeBuy"
                >
                  0.3675
                </span>
                <span
                  data-v-9b31e286=""
                  className="flex items-center text-v3PrimaryText !text-v3TradeBuy"
                >
                  <span data-v-9b31e286="" className="text-12px">
                    (
                  </span>
                  <div
                    data-v-9b31e286=""
                    className="min-w-42px flex items-center justify-center"
                  >
                    <span
                      data-v-9b31e286=""
                      dir="ltr"
                      className="text-12px leading-16px font-500 flex flex-nowrap flex-shrink-0 text-v3TradeBuyText"
                    >
                      {/**/}+15.89%
                    </span>
                  </div>
                  <span data-v-9b31e286="" className="text-12px">
                    )
                  </span>
                </span>
              </div>
              <div
                data-v-9b31e286=""
                className="flex gap-4px items-center px-8px box-border fill-width"
              >
                <span
                  data-v-9b31e286=""
                  className="text-12px font-500 leading-16px text-v3PrimaryText"
                >
                  IO/USDT
                </span>
                <span
                  data-v-9b31e286=""
                  className="text-12px leading-16px font-500 text-v3PrimaryText !text-v3TradeSell"
                >
                  5.026
                </span>
                <span
                  data-v-9b31e286=""
                  className="flex items-center text-v3PrimaryText !text-v3TradeSell"
                >
                  <span data-v-9b31e286="" className="text-12px">
                    (
                  </span>
                  <div
                    data-v-9b31e286=""
                    className="min-w-42px flex items-center justify-center"
                  >
                    <span
                      data-v-9b31e286=""
                      dir="ltr"
                      className="text-12px leading-16px font-500 flex flex-nowrap flex-shrink-0 text-v3TradeSellText"
                    >
                      {/**/}-6.35%
                    </span>
                  </div>
                  <span data-v-9b31e286="" className="text-12px">
                    )
                  </span>
                </span>
              </div>
              <div
                data-v-9b31e286=""
                className="flex gap-4px items-center px-8px box-border fill-width"
              >
                <span
                  data-v-9b31e286=""
                  className="text-12px font-500 leading-16px text-v3PrimaryText"
                >
                  SOL/USDT
                </span>
                <span
                  data-v-9b31e286=""
                  className="text-12px leading-16px font-500 text-v3PrimaryText !text-v3TradeSell"
                >
                  144.498
                </span>
                <span
                  data-v-9b31e286=""
                  className="flex items-center text-v3PrimaryText !text-v3TradeSell"
                >
                  <span data-v-9b31e286="" className="text-12px">
                    (
                  </span>
                  <div
                    data-v-9b31e286=""
                    className="min-w-42px flex items-center justify-center"
                  >
                    <span
                      data-v-9b31e286=""
                      dir="ltr"
                      className="text-12px leading-16px font-500 flex flex-nowrap flex-shrink-0 text-v3TradeSellText"
                    >
                      {/**/}-2.33%
                    </span>
                  </div>
                  <span data-v-9b31e286="" className="text-12px">
                    )
                  </span>
                </span>
              </div>
              <div
                data-v-9b31e286=""
                className="flex gap-4px items-center px-8px box-border fill-width"
              >
                <span
                  data-v-9b31e286=""
                  className="text-12px font-500 leading-16px text-v3PrimaryText"
                >
                  TONCOIN/USDT
                </span>
                <span
                  data-v-9b31e286=""
                  className="text-12px leading-16px font-500 text-v3PrimaryText !text-v3TradeBuy"
                >
                  7.98425
                </span>
                <span
                  data-v-9b31e286=""
                  className="flex items-center text-v3PrimaryText !text-v3TradeBuy"
                >
                  <span data-v-9b31e286="" className="text-12px">
                    (
                  </span>
                  <div
                    data-v-9b31e286=""
                    className="min-w-42px flex items-center justify-center"
                  >
                    <span
                      data-v-9b31e286=""
                      dir="ltr"
                      className="text-12px leading-16px font-500 flex flex-nowrap flex-shrink-0 text-v3TradeBuyText"
                    >
                      {/**/}+2.10%
                    </span>
                  </div>
                  <span data-v-9b31e286="" className="text-12px">
                    )
                  </span>
                </span>
              </div>
              <div
                data-v-9b31e286=""
                className="flex gap-4px items-center px-8px box-border fill-width"
              >
                <span
                  data-v-9b31e286=""
                  className="text-12px font-500 leading-16px text-v3PrimaryText"
                >
                  NOT/USDT
                </span>
                <span
                  data-v-9b31e286=""
                  className="text-12px leading-16px font-500 text-v3PrimaryText !text-v3TradeBuy"
                >
                  0.019682
                </span>
                <span
                  data-v-9b31e286=""
                  className="flex items-center text-v3PrimaryText !text-v3TradeBuy"
                >
                  <span data-v-9b31e286="" className="text-12px">
                    (
                  </span>
                  <div
                    data-v-9b31e286=""
                    className="min-w-42px flex items-center justify-center"
                  >
                    <span
                      data-v-9b31e286=""
                      dir="ltr"
                      className="text-12px leading-16px font-500 flex flex-nowrap flex-shrink-0 text-v3TradeBuyText"
                    >
                      {/**/}+6.52%
                    </span>
                  </div>
                  <span data-v-9b31e286="" className="text-12px">
                    )
                  </span>
                </span>
              </div>
              <div
                data-v-9b31e286=""
                className="flex gap-4px items-center px-8px box-border fill-width"
              >
                <span
                  data-v-9b31e286=""
                  className="text-12px font-500 leading-16px text-v3PrimaryText"
                >
                  BTC/USDT
                </span>
                <span
                  data-v-9b31e286=""
                  className="text-12px leading-16px font-500 text-v3PrimaryText !text-v3TradeSell"
                >
                  66,140.97
                </span>
                <span
                  data-v-9b31e286=""
                  className="flex items-center text-v3PrimaryText !text-v3TradeSell"
                >
                  <span data-v-9b31e286="" className="text-12px">
                    (
                  </span>
                  <div
                    data-v-9b31e286=""
                    className="min-w-42px flex items-center justify-center"
                  >
                    <span
                      data-v-9b31e286=""
                      dir="ltr"
                      className="text-12px leading-16px font-500 flex flex-nowrap flex-shrink-0 text-v3TradeSellText"
                    >
                      {/**/}-1.29%
                    </span>
                  </div>
                  <span data-v-9b31e286="" className="text-12px">
                    )
                  </span>
                </span>
              </div>
              <div
                data-v-9b31e286=""
                className="flex gap-4px items-center px-8px box-border fill-width"
              >
                <span
                  data-v-9b31e286=""
                  className="text-12px font-500 leading-16px text-v3PrimaryText"
                >
                  BGB/USDT
                </span>
                <span
                  data-v-9b31e286=""
                  className="text-12px leading-16px font-500 text-v3PrimaryText !text-v3TradeSell"
                >
                  1.15209
                </span>
                <span
                  data-v-9b31e286=""
                  className="flex items-center text-v3PrimaryText !text-v3TradeSell"
                >
                  <span data-v-9b31e286="" className="text-12px">
                    (
                  </span>
                  <div
                    data-v-9b31e286=""
                    className="min-w-42px flex items-center justify-center"
                  >
                    <span
                      data-v-9b31e286=""
                      dir="ltr"
                      className="text-12px leading-16px font-500 flex flex-nowrap flex-shrink-0 text-v3TradeSellText"
                    >
                      {/**/}-0.70%
                    </span>
                  </div>
                  <span data-v-9b31e286="" className="text-12px">
                    )
                  </span>
                </span>
              </div>
              <div
                data-v-9b31e286=""
                className="flex gap-4px items-center px-8px box-border fill-width"
              >
                <span
                  data-v-9b31e286=""
                  className="text-12px font-500 leading-16px text-v3PrimaryText"
                >
                  MAND/USDT
                </span>
                <span
                  data-v-9b31e286=""
                  className="text-12px leading-16px font-500 text-v3PrimaryText !text-v3TradeBuy"
                >
                  0.77483
                </span>
                <span
                  data-v-9b31e286=""
                  className="flex items-center text-v3PrimaryText !text-v3TradeBuy"
                >
                  <span data-v-9b31e286="" className="text-12px">
                    (
                  </span>
                  <div
                    data-v-9b31e286=""
                    className="min-w-42px flex items-center justify-center"
                  >
                    <span
                      data-v-9b31e286=""
                      dir="ltr"
                      className="text-12px leading-16px font-500 flex flex-nowrap flex-shrink-0 text-v3TradeBuyText"
                    >
                      {/**/}+209.93%
                    </span>
                  </div>
                  <span data-v-9b31e286="" className="text-12px">
                    )
                  </span>
                </span>
              </div>
              <div
                data-v-9b31e286=""
                className="flex gap-4px items-center px-8px box-border fill-width"
              >
                <span
                  data-v-9b31e286=""
                  className="text-12px font-500 leading-16px text-v3PrimaryText"
                >
                  PEPE/USDT
                </span>
                <span
                  data-v-9b31e286=""
                  className="text-12px leading-16px font-500 text-v3PrimaryText !text-v3TradeSell"
                >
                  0.00001196849
                </span>
                <span
                  data-v-9b31e286=""
                  className="flex items-center text-v3PrimaryText !text-v3TradeSell"
                >
                  <span data-v-9b31e286="" className="text-12px">
                    (
                  </span>
                  <div
                    data-v-9b31e286=""
                    className="min-w-42px flex items-center justify-center"
                  >
                    <span
                      data-v-9b31e286=""
                      dir="ltr"
                      className="text-12px leading-16px font-500 flex flex-nowrap flex-shrink-0 text-v3TradeSellText"
                    >
                      {/**/}-0.97%
                    </span>
                  </div>
                  <span data-v-9b31e286="" className="text-12px">
                    )
                  </span>
                </span>
              </div>
              <div
                data-v-9b31e286=""
                className="flex gap-4px items-center px-8px box-border fill-width"
              >
                <span
                  data-v-9b31e286=""
                  className="text-12px font-500 leading-16px text-v3PrimaryText"
                >
                  ETH/USDT
                </span>
                <span
                  data-v-9b31e286=""
                  className="text-12px leading-16px font-500 text-v3PrimaryText !text-v3TradeBuy"
                >
                  3,542.60
                </span>
                <span
                  data-v-9b31e286=""
                  className="flex items-center text-v3PrimaryText !text-v3TradeBuy"
                >
                  <span data-v-9b31e286="" className="text-12px">
                    (
                  </span>
                  <div
                    data-v-9b31e286=""
                    className="min-w-42px flex items-center justify-center"
                  >
                    <span
                      data-v-9b31e286=""
                      dir="ltr"
                      className="text-12px leading-16px font-500 flex flex-nowrap flex-shrink-0 text-v3TradeBuyText"
                    >
                      {/**/}+0.67%
                    </span>
                  </div>
                  <span data-v-9b31e286="" className="text-12px">
                    )
                  </span>
                </span>
              </div>
              <div
                data-v-9b31e286=""
                className="flex gap-4px items-center px-8px box-border fill-width"
              >
                <span
                  data-v-9b31e286=""
                  className="text-12px font-500 leading-16px text-v3PrimaryText"
                >
                  PIRATE/USDT
                </span>
                <span
                  data-v-9b31e286=""
                  className="text-12px leading-16px font-500 text-v3PrimaryText !text-v3TradeBuy"
                >
                  0.3675
                </span>
                <span
                  data-v-9b31e286=""
                  className="flex items-center text-v3PrimaryText !text-v3TradeBuy"
                >
                  <span data-v-9b31e286="" className="text-12px">
                    (
                  </span>
                  <div
                    data-v-9b31e286=""
                    className="min-w-42px flex items-center justify-center"
                  >
                    <span
                      data-v-9b31e286=""
                      dir="ltr"
                      className="text-12px leading-16px font-500 flex flex-nowrap flex-shrink-0 text-v3TradeBuyText"
                    >
                      {/**/}+15.89%
                    </span>
                  </div>
                  <span data-v-9b31e286="" className="text-12px">
                    )
                  </span>
                </span>
              </div>
              <div
                data-v-9b31e286=""
                className="flex gap-4px items-center px-8px box-border fill-width"
              >
                <span
                  data-v-9b31e286=""
                  className="text-12px font-500 leading-16px text-v3PrimaryText"
                >
                  IO/USDT
                </span>
                <span
                  data-v-9b31e286=""
                  className="text-12px leading-16px font-500 text-v3PrimaryText !text-v3TradeSell"
                >
                  5.026
                </span>
                <span
                  data-v-9b31e286=""
                  className="flex items-center text-v3PrimaryText !text-v3TradeSell"
                >
                  <span data-v-9b31e286="" className="text-12px">
                    (
                  </span>
                  <div
                    data-v-9b31e286=""
                    className="min-w-42px flex items-center justify-center"
                  >
                    <span
                      data-v-9b31e286=""
                      dir="ltr"
                      className="text-12px leading-16px font-500 flex flex-nowrap flex-shrink-0 text-v3TradeSellText"
                    >
                      {/**/}-6.35%
                    </span>
                  </div>
                  <span data-v-9b31e286="" className="text-12px">
                    )
                  </span>
                </span>
              </div>
              <div
                data-v-9b31e286=""
                className="flex gap-4px items-center px-8px box-border fill-width"
              >
                <span
                  data-v-9b31e286=""
                  className="text-12px font-500 leading-16px text-v3PrimaryText"
                >
                  SOL/USDT
                </span>
                <span
                  data-v-9b31e286=""
                  className="text-12px leading-16px font-500 text-v3PrimaryText !text-v3TradeSell"
                >
                  144.498
                </span>
                <span
                  data-v-9b31e286=""
                  className="flex items-center text-v3PrimaryText !text-v3TradeSell"
                >
                  <span data-v-9b31e286="" className="text-12px">
                    (
                  </span>
                  <div
                    data-v-9b31e286=""
                    className="min-w-42px flex items-center justify-center"
                  >
                    <span
                      data-v-9b31e286=""
                      dir="ltr"
                      className="text-12px leading-16px font-500 flex flex-nowrap flex-shrink-0 text-v3TradeSellText"
                    >
                      {/**/}-2.33%
                    </span>
                  </div>
                  <span data-v-9b31e286="" className="text-12px">
                    )
                  </span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="market-wrap" data-v-70542be6="">
        <div
          className="page-nav-step <md:pb-24px !md:py-24px mx-auto center"
          data-v-70542be6=""
        >
          <div
            aria-label="Breadcrumb"
            role="navigation"
            className="bit-breadcrumb"
            data-v-70542be6=""
          >
            <span className="bit-breadcrumb__item" data-v-70542be6="">
              <span role="link" className="bit-breadcrumb__inner is-link">
                {/**/}Sising{/**/}
              </span>
              <span role="presentation" className="bit-breadcrumb__separator">
                /
              </span>
            </span>
            <span className="bit-breadcrumb__item" data-v-70542be6="">
              <span role="link" className="bit-breadcrumb__inner is-link ">
                {/**/}
                {t("Thị trường")}
                {/**/}
              </span>
              <span role="presentation" className="bit-breadcrumb__separator">
                /
              </span>
            </span>
            <span
              className="bit-breadcrumb__item"
              data-v-70542be6=""
              aria-current="page"
            >
              <span role="link" className="bit-breadcrumb__inner ">
                {/**/}
                {t("Thị trường")}
                {/**/}
              </span>
              <span role="presentation" className="bit-breadcrumb__separator">
                /
              </span>
            </span>
          </div>
        </div>
        <div
          className="market-header mb-20px center"
          data-v-e6d45f74=""
          data-v-70542be6=""
        >
          <h1 className="headline_module__title text-[#fff]" data-v-e6d45f74="">
            {t("Thị trường")}
          </h1>
        </div>
        <div
          data-micro-type="RecommendCoins"
          className="center micro micro-dark"
          data-v-70542be6=""
          data-micro-id={54421255}
        >
          <div className="flex gap-16px flex-col lg:flex-row pt-20px pb-4px md:pt-20px md:pb-12px">
            <div className="lg:w-[calc(50%-8px)] hidden">
              <div
                data-v-573dee0d=""
                className="w-auto overflow-hidden flex flex-1 flex-col gap-15px md:gap-23px coin-card border-1px border-solid border-borderStrengthOne px-16px py-15px md:p-24px cursor-pointer !pb-15px bg-bg rounded-8px"
              >
                <div
                  data-v-573dee0d=""
                  className="flex flex-1 overflow-hidden items-start gap-12px md:!gap-20px lg:!gap-12px 2xl:!gap-20px"
                >
                  <div
                    data-v-573dee0d=""
                    className="mi-skeleton w-40px h-40px md:w-48px md:h-48px w-40px h-40px md:w-48px md:h-48px"
                  >
                    <div
                      data-v-573dee0d=""
                      className="mi-skeleton__item mi-skeleton__circle mi-skeleton__circle--default w-40px h-40px md:w-48px md:h-48px"
                    >
                      {/*v-if*/}
                    </div>
                  </div>
                  <div
                    data-v-573dee0d=""
                    className="flex flex-1 flex-col gap-12px md:gap-16px overflow-hidden"
                  >
                    <div className="flex gap-24px md:!gap-64px lg:!gap-48px 2xl:!gap-64px">
                      <div className="flex flex-col gap-y-4px max-w-70px whitespace-nowrap">
                        <div className="text-ellipsis overflow-hidden text-14px leading-20px text-dsColorTextPrimary font-600">
                          --
                        </div>
                        <div className="text-ellipsis overflow-hidden text-12px leading-120% text-dsColorTextTertiary">
                          --
                        </div>
                      </div>
                      <div className="flex flex-col gap-y-4px">
                        <div className="text-ellipsis overflow-hidden text-14px leading-20px text-dsColorTextPrimary font-600">
                          --
                        </div>
                        <div className="text-ellipsis overflow-hidden text-12px leading-120% text-dsColorTextTertiary">
                          {t("Giá gần nhất")}
                        </div>
                      </div>
                      <div className="flex flex-col gap-y-4px">
                        <div className="text-14px leading-20px text-contentInverseTertiary font-600">
                          --
                        </div>
                        <div className="text-ellipsis overflow-hidden text-12px leading-120% text-dsColorTextTertiary">
                          {t("Tăng 24 giờ")}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  data-v-573dee0d=""
                  className="pt-16px border-t-1px border-line border-[#DEDFE0]"
                >
                  <div
                    data-v-f24d17e3=""
                    data-v-573dee0d=""
                    className="flex items-center flex-nowrap cursor-pointer"
                  >
                    <svg
                      data-v-f24d17e3=""
                      xmlns="http://www.w3.org/2000/svg"
                      width={16}
                      height={16}
                      viewBox="0 0 16 16"
                      fill="none"
                      className="w-16px h-16px text-primaryText"
                    >
                      <rect
                        x="1.5"
                        y="4.95453"
                        width="2.36364"
                        height="4.72727"
                        fill="var(--content-primary)"
                      />
                      <path
                        d="M5.04565 4.65909L11.2198 2.13331C11.3753 2.06969 11.5457 2.18406 11.5457 2.35207V12.2843C11.5457 12.4523 11.3753 12.5667 11.2198 12.5031L5.04565 9.97727V4.65909Z"
                        fill="var(--content-primary)"
                      />
                      <path
                        d="M4.32642 10.2727L4.0309 12.0455"
                        stroke="var(--content-primary)"
                        strokeWidth="1.77273"
                        strokeLinecap="square"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M12.1365 9.6818C12.1365 9.6818 12.1366 9.6818 12.1367 9.6818C13.4421 9.6818 14.5003 8.62357 14.5003 7.31817C14.5003 6.01276 13.4421 4.95453 12.1367 4.95453C12.1366 4.95453 12.1365 4.95453 12.1365 4.95453V9.6818Z"
                        fill="#8E8E92"
                      />
                    </svg>
                    <div
                      data-v-f24d17e3=""
                      className="h-16px text-ellipsis overflow-hidden whitespace-nowrap mx-4px flex-1 text-12px leading-16px text-dsColorTextPrimary"
                    >
                      --
                    </div>
                    <i
                      data-v-f24d17e3=""
                      className="mi-icon cursor-pointer color-contentTertiary"
                      style={{ fontSize: 12 }}
                    >
                      <svg
                        data-v-f24d17e3=""
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                        aria-hidden="true"
                      >
                        <path d="M17.03 12.53l-7.5 7.5a.75.75 0 11-1.06-1.06L15.44 12 8.47 5.03a.75.75 0 111.06-1.06l7.5 7.5a.75.75 0 010 1.06z" />
                      </svg>
                    </i>
                  </div>
                </div>
              </div>
            </div>
            <div className="lg:w-[calc(50%-8px)]">
              <div
                data-v-573dee0d=""
                className="w-auto overflow-hidden flex flex-1 flex-col gap-15px md:gap-23px coin-card border-1px border-solid border-borderStrengthOne px-16px py-15px md:p-24px cursor-pointer !pb-15px bg-bg rounded-8px"
              >
                <div
                  data-v-573dee0d=""
                  className="flex flex-1 overflow-hidden items-start gap-12px md:!gap-20px lg:!gap-12px 2xl:!gap-20px"
                >
                  <img
                    data-v-573dee0d=""
                    className="w-[25px] h-25px rounded-full md:w-48px md:h-48px"
                    src={appGlobal?.LOGO_APP?.value}
                    alt="coin"
                  />
                  <div
                    data-v-573dee0d=""
                    className="flex flex-1 flex-col gap-12px md:gap-16px overflow-hidden"
                  >
                    <div className="min-h-38px">
                      <div className="flex gap-24px md:!gap-64px lg:!gap-48px 2xl:!gap-64px">
                        <div className="flex flex-col gap-y-4px">
                          <div className="text-ellipsis overflow-hidden text-[20px] leading-20px text-dsColorTextPrimary font-600">
                            GOM/USDT
                          </div>
                          <div className="text-ellipsis overflow-hidden text-12px leading-120% text-dsColorTextTertiary">
                            Sising
                          </div>
                        </div>
                        <div className="flex flex-col gap-y-4px">
                          <div className="text-ellipsis overflow-hidden text-14px leading-20px text-dsColorTextPrimary font-600">
                            {appGlobal?.PRICE_GOM?.value}$
                          </div>
                          <div className="text-ellipsis overflow-hidden text-12px leading-120% text-dsColorTextTertiary">
                            {t("Giá gần nhất")}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      data-v-573dee0d=""
                      className="gap-8px flex flex-nowrap overflow-hidden lg:h-22px"
                    >
                      <div className="items-center justify-center py-4px px-8px gap-2px rounded-4px text-ellipsis whitespace-nowrap bg-bgSecondary text-10px leading-14px text-contentTertiary">
                        Inno
                      </div>
                      <div className="items-center justify-center py-4px px-8px gap-2px rounded-4px text-ellipsis whitespace-nowrap bg-bgSecondary text-10px leading-14px text-contentTertiary">
                        Layer 2
                      </div>
                      <div className="items-center justify-center py-4px px-8px gap-2px rounded-4px text-ellipsis whitespace-nowrap bg-bgSecondary text-10px leading-14px text-contentTertiary">
                        Web3
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <span id="go-anchor" data-v-70542be6="" />
        <div
          className="center"
          style={{ minHeight: "50vh" }}
          data-v-70542be6=""
        >
          <div className="table-tab" style={{ top: 64 }} data-v-70542be6="">
            <div
              className="flex justify-between iphone:w-full"
              data-v-70542be6=""
            >
              {/**/}
              <div
                data-v-70542be6=""
                className="search headline_module__title bit-input bit-input--medium bit-input--round bit-input--prefix bit-input--suffix bit-input--search"
                size="medium"
                round=""
                placeholder={t("Tìm kiếm tên coin")}
              >
                {/**/}
                {/**/}
                <input
                  type="text"
                  autoComplete="off"
                  placeholder={t("Tìm kiếm tên coin")}
                  className="bit-input__inner"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
                <span className="bit-input__prefix">
                  <i className="bit-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="currentColor"
                      aria-hidden="true"
                    >
                      <path d="M21.53 20.47l-4.694-4.694a8.26 8.26 0 10-1.06 1.06l4.693 4.695a.75.75 0 001.062-1.062zM3.75 10.5a6.75 6.75 0 116.75 6.75 6.758 6.758 0 01-6.75-6.75z" />
                    </svg>
                  </i>
                  {/**/}
                </span>
                {/**/}
                {/**/}
                {/**/}
                {/**/}
                {/**/}
              </div>
            </div>
          </div>
          <div className="relative overflow-x-auto">
            <table className="w-full ">
              <thead className="">
                <tr className="text-[#8e8e92] font-[500]">
                  <th scope="col" className="px-6 py-3">
                    {t("Cặp giao dịch")}
                  </th>
                  <th scope="col" className="px-6 py-3 hidden md:block">
                    {t("Giá mới nhất")}
                  </th>
                  <th scope="col" className="px-6 py-3 ">
                    {t("Biến động 24h")}
                  </th>
                  <th scope="col" className="px-6 py-3 hidden md:block ">
                    {t("Khối lượng")}
                  </th>
                  <th scope="col" className="px-6 py-3">
                    {t("24h qua")}
                  </th>
                  <th scope="col" className="px-6 py-3 hidden md:block">
                    {t("Hoạt động")}
                  </th>
                </tr>
              </thead>
              <tbody>
                {tokens?.total > 0 &&
                  tokens?.tokens?.map((i) => (
                    <tr
                      className=" border-[#9999]  text-[#fff] font-[500] cursor-pointer"
                      key={i?.id}
                      onClick={() => {
                        if (breakpoint === "mobile")
                          return naviagte(`/trading?spot=${i?.symbol}`);
                      }}
                    >
                      <th scope="row" className="px-6 py-4 font-medium ">
                        <div className="flex gap-2 items-center">
                          <img
                            data-v-5e1165f3=""
                            alt="getCoinIconBySymbol-4-BTC"
                            loading="lazy"
                            src={`https://s2.coinmarketcap.com/static/img/coins/64x64/${i.id}.png`}
                            className="w-24px h-24px rounded-24px"
                          />
                          {i?.symbol}/USDT
                        </div>
                      </th>
                      <td className="px-6 py-4 hidden md:block">
                        {formatNumber(i?.quote?.USD?.price?.toFixed(2))}
                      </td>
                      <td className="px-6 py-4 min-w-[70px]">
                        <div className="block md:hidden">
                          {formatNumber(i?.quote?.USD?.price?.toFixed(2))}
                        </div>
                        <div
                          className={clsx("font-[500]", {
                            "text-[#5bd690]":
                              i?.quote?.USD?.percent_change_24h >= 0,
                            "text-[#f1493f]":
                              i?.quote?.USD?.percent_change_24h < 0,
                          })}
                        >
                          {i?.quote?.USD?.percent_change_24h?.toFixed(2)}%
                        </div>
                      </td>
                      <td className="px-6 py-4 hidden md:block">
                        {formatVolume(i?.quote?.USD?.volume_24h)}
                      </td>
                      <td className="px-6 py-4">
                        <div className="">
                          <img
                            className={clsx("svg-custom w-[70px]", {
                              isUp: i?.quote?.USD?.percent_change_24h >= 0,
                            })}
                            src={`https://s3.coinmarketcap.com/generated/sparklines/web/1d/2781/${i?.id}.svg`}
                          />
                        </div>
                      </td>
                      <td className="px-6 py-4 hidden md:block">
                        <div className="flex gap-3 items-center">
                          <Link
                            to="#"
                            className="text-primaryHoverBg font-[700]"
                          >
                            {t("Chi tiết")}
                          </Link>
                          <Link
                            to={`/trading?spot=${i?.symbol}`}
                            className="text-primaryHoverBg font-[700]"
                          >
                            {t("Giao dịch")}
                          </Link>
                        </div>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
          {!debounceValue && (
            <PaginationAntd
              defaultCurrent={1}
              total={tokens?.total}
              showSizeChanger={false}
              onChange={onChangePage}
            />
          )}
        </div>
        <div data-v-70542be6="" style={{ minHeight: 0 }}>
          <div
            data-v-61c0d57b=""
            data-v-70542be6=""
            className="banner mt-60px center"
          >
            <Swiper
              slidesPerView={breakpoint === "mobile" ? 2 : 3}
              loop
              spaceBetween={10}
              autoplay={{
                delay: 1500,
                disableOnInteraction: false,
              }}
              pagination={true}
              modules={[Pagination, Autoplay]}
              centeredSlides
              className="mySwiper"
            >
              <SwiperSlide>
                <img
                  src="https://file.coin98.com/insights/bscgamefi-1631787860451.png"
                  alt=""
                  className="h-full md:h-[200px] w-[400px] md:w-full"
                />
              </SwiperSlide>
              <SwiperSlide>
                <img
                  src="https://file.publish.vn/coin98/2021-09/dvision-metaverse-1631529717729.png"
                  alt=""
                  className="h-full md:h-[200px] w-[400px] md:w-full"
                />
              </SwiperSlide>
              <SwiperSlide>
                <img
                  src="https://files.amberblocks.com/media/chnbzaa92ook5tnj/posts/phc6eron4qjfof22/fsmrj9mwrcefmvdbt9yluwglkhdvax6d/solana-ethereum-revenue.jpeg"
                  alt=""
                  className="h-full md:h-[200px] w-[400px] md:w-full"
                />
              </SwiperSlide>
              <SwiperSlide>
                <img
                  src="https://files.amberblocks.com/thumbnail/chnbzaa92ook5tnj/posts/pbglbp826kjlkduf/f38aoxap3lve4so9rhly9bbrbzm2pr2n/meme-coin-sundog.jpg"
                  alt=""
                  className="h-full md:h-[200px] w-[400px] md:w-full"
                />
              </SwiperSlide>
              <SwiperSlide>
                <img
                  src="https://files.amberblocks.com/thumbnail/chnbzaa92ook5tnj/posts/pwn2fr28y4l8630o/f3yv9l4r9415kn0iwl25jgnr5b8bujfi/solana-etf.jpg"
                  alt=""
                  className="h-full md:h-[200px] w-[400px] md:w-full"
                />
              </SwiperSlide>
              <SwiperSlide>
                <img
                  src="https://files.amberblocks.com/thumbnail/chnbzaa92ook5tnj/posts/pq2x8z68bpxzvspm/f03lzo1az0md9k9jkk9haxljsoqpbz8p/su-that-memecoin.jpg"
                  alt=""
                  className="h-full md:h-[200px] w-[400px] md:w-full"
                />
              </SwiperSlide>
            </Swiper>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Market;
